<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;">
  <app-select2 #demandeurs
               [values]="[]"
               [limitSelectedItems]="1"
               [select2Title]="'Filtre sur un demandeur'"
               [searchPlaceHolder]="'Rechercher un demandeur'"
               [fieldsDisplay]="['last_name', 'first_name']"
               [confirmModale]="false"
               [expanded]="true"
               [toolTip]="'Rechercher un demandeur par son nom ou prénom'"
               (actionItem)="doAction($event)"
  ></app-select2>

  <div>
    <button color="accent" class="mat-button mat-small"
            mat-raised-button (click)="onValidate($event)"
            matTooltip="Filtrer sur ce demandeur" [disabled]="! searchIndividu" data-cy="btn-demandeur-deposits-filtering">Filtrer</button>
  </div>
</div>
